module.exports = {
	BASE_URL: "https://tools-api-service.staging.sharechat.com",
	UPLOAD_MEDIA_API:
		"https://apis.staging.sharechat.com/media-upload-service/v1.0.0/fileUpload",
	SHARECHAT_DOMAIN: "https://staging.sharechat.com",
	razorPayMTGPLKey: "rzp_test_fy6C4mPlG2Rzxk",
	razorpayMTPLKey: "rzp_test_fy6C4mPlG2Rzxk",
	razorpayMojKey: "rzp_test_Qect8yrJ3XmBoL",
	JEET11_API_GATEWAY_BASE_URL: "https://api-gateway.staging.jeet11.com/",
	FCM_CONFIG: {
		apiKey: "AIzaSyA11CM6biUWhds2uT_SJdNLJycwAJOwEqo",
		authDomain: "bharat11-staging.firebaseapp.com",
		databaseURL: "https://bharat11-staging.firebaseio.com",
		projectId: "bharat11-staging",
		storageBucket: "bharat11-staging.appspot.com",
		messagingSenderId: "741190719651",
		appId: "1:741190719651:web:03927bf5c2d6187f988716",
		measurementId: "G-0PVFL8SWVE"
	},
	FIREBASE_VERSION: "8.2.0",
	ALL_SPORTS: [
		{ id: "1", name: "Cricket" },
		{ id: "2", name: "Football" },
		{ id: "3", name: "Kabaddi" }
	],
	GOOGLE_API_KEY: "AIzaSyDWosTDLWO9vjLVUg7W3ztnaaWHjvokntc",
	SHARECHAT_API_DOMAIN: "https://apis.staging.sharechat.com",
	MOJ_TOOLS_BASE_URL: "https://moj-tools-api-service.staging.sharechat.com",
	MOJ_TOOLS_ACCESS_TOKEN: "291:ocikpD0fxmYJa47X"
};
